//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import Maintanance from "../pages/Maintanance";

// https://adarshaacharya.com.np/blog/role-based-auth-with-react-router-v6

/**
 * Top level application router
 *
 * @returns {JSX.Element}
 */
const Router = () => {
  return (
    <Routes>
      
        <Route path={"/maintanance"} element={<Maintanance />} />
        <Route path="/*" element={<PageNotFound />} />
      
    </Routes>
  );
};

export default Router;